import { createSvgIcon } from '@mui/material';

export const ENG = createSvgIcon(
  <svg
    id='a'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 76 76'
  >
    <defs>
      <linearGradient
        id='b'
        x1='34.29'
        y1='64.08'
        x2='34.29'
        y2='18.88'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='48.06'
        y1='45.5'
        x2='48.06'
        y2='30.78'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='48.29'
        y1='28.59'
        x2='63.59'
        y2='13.29'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='42.72'
        y1='28.94'
        x2='42.72'
        y2='16.35'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='12.05'
        y1='22.78'
        x2='25.71'
        y2='9.12'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#414cc8' />
        <stop offset='1' stopColor='#2b3493' />
      </linearGradient>
    </defs>
    <path
      d='M52.73,28.7l3.34-3.34c.26-.26.47-.57.61-.92.14-.34.22-.71.22-1.08s-.07-.74-.22-1.08c-.14-.34-.35-.65-.61-.92l-2-2c-.53-.53-1.25-.83-2-.83s-1.47.3-2,.83l-3.36,3.36c-1.66-1.03-3.48-1.78-5.38-2.23v-4.75c0-.75-.3-1.47-.83-2-.53-.53-1.25-.83-2-.83h-2.82c-.75,0-1.47.3-2,.83-.53.53-.83,1.25-.83,2v4.75c-1.9.45-3.72,1.2-5.38,2.23l-3.36-3.36c-.53-.53-1.25-.83-2-.83s-1.47.3-2,.83l-2,2c-.26.26-.47.57-.61.92-.14.34-.22.71-.22,1.08,0,.37.07.74.21,1.08.14.34.35.65.61.92l3.36,3.36c-1.03,1.66-1.78,3.48-2.23,5.38h-4.75c-.75,0-1.47.3-2,.83-.53.53-.83,1.25-.83,2v2.82c0,.75.3,1.47.83,2,.53.53,1.25.83,2,.83h4.75c.45,1.9,1.2,3.72,2.23,5.38l-3.36,3.36c-1.1,1.1-1.1,2.89,0,3.99l2,2c1.1,1.1,2.89,1.1,3.99,0l3.36-3.36c1.6.99,3.33,1.72,5.15,2.18-.62-1.4-.97-2.99-.97-4.73,0-.95.19-1.88.55-2.76.01-.03.03-.06.04-.1-1.16-.55-2.22-1.29-3.14-2.22-2.12-2.12-3.31-4.99-3.31-7.99s1.19-5.87,3.31-7.99c2.12-2.12,4.99-3.31,7.99-3.31,2.16,0,4.27.62,6.06,1.77,1.5-.76,3.18-1.16,4.89-1.16s3.22.37,4.67,1.05Z'
      fill='url(#b)'
      strokeWidth='0'
    />
    <path
      d='M40.7,38.86c0-4.06,3.31-7.37,7.37-7.36,4.05,0,7.37,3.32,7.36,7.36-.01,4.09-3.3,7.36-7.39,7.36-4.03,0-7.33-3.31-7.33-7.36h0Z'
      fill='url(#c)'
      strokeWidth='0'
    />
    <path
      d='M58.08,57.32c-.62,0-1.29-.1-1.93-.31-.14-.05-.22-.02-.32.08-1.62,1.62-3.23,3.24-4.86,4.86-.76.76-1.69,1.01-2.72.73-1.05-.29-1.72-1.01-1.96-2.07-.22-.96.03-1.82.72-2.52,1.62-1.64,3.25-3.26,4.89-4.89.11-.11.14-.2.09-.36-.98-3.04.41-6.35,3.28-7.77,1.14-.57,2.35-.78,3.62-.63.59.07.85.64.56,1.16-.06.1-.14.19-.22.27-.58.58-1.16,1.16-1.74,1.74-1.06,1.06-1.06,2.81-.01,3.88,1.08,1.09,2.83,1.12,3.91.06.61-.59,1.2-1.2,1.8-1.8.24-.24.52-.35.86-.27.32.08.5.31.54.64.32,2.74-1.15,5.4-3.64,6.58-.89.42-1.82.63-2.85.63h0Z'
      fill='url(#d)'
      strokeWidth='0'
    />
    <path
      d='M50.27,48.07h0c-.11.5-.24.99-.33,1.48-.16.91-.14,1.82.02,2.73.03.15,0,.24-.11.34-1.35,1.35-2.7,2.7-4.05,4.05-1.05,1.05-1.53,2.31-1.39,3.79h0c0,.1-.09.17-.18.15-.38-.08-.74-.15-1.1-.24-1.67-.41-3.25-1.05-4.64-2.09-1.71-1.28-2.81-2.95-3.17-5.07-.15-.88-.22-1.77.07-2.65.5-1.49,1.89-2.5,3.46-2.5,3.75,0,7.49,0,11.24,0,.07,0,.14,0,.2.01,0,0,0,0,0,0h0Z'
      fill='url(#e)'
      strokeWidth='0'
    />
    <path
      d='M9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='url(#f)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M6.96,53.53c2.07-5.05,7.04-8.61,12.84-8.61,5.37,0,10.02,3.05,12.33,7.51,6.25.18,11.26,5.29,11.26,11.58s-5.19,11.59-11.59,11.59H11.9c-6.4,0-11.59-5.19-11.59-11.59,0-4.64,2.72-8.64,6.66-10.49ZM9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='#fff'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M12.35,63.04h3.63v1.36h-3.63v-1.36ZM12.47,66.14h4.1v1.4h-5.84v-7.54h5.7v1.4h-3.96v4.74ZM17.97,67.54v-7.54h1.44l4.45,5.43h-.7v-5.43h1.72v7.54h-1.43l-4.46-5.43h.7v5.43h-1.72ZM30.3,67.67c-.6,0-1.15-.09-1.65-.28-.5-.19-.93-.47-1.3-.82-.37-.35-.65-.76-.86-1.24-.2-.47-.3-.99-.3-1.56s.1-1.09.3-1.56c.21-.47.5-.89.87-1.24.37-.35.81-.62,1.31-.81.5-.19,1.06-.29,1.66-.29.67,0,1.27.11,1.8.33.54.22.99.55,1.36.97l-1.12,1.03c-.27-.29-.57-.5-.89-.64-.32-.14-.67-.22-1.06-.22s-.7.06-1,.17c-.3.11-.56.28-.79.5-.22.22-.38.47-.51.76-.11.29-.17.62-.17.98s.06.67.17.97c.12.29.29.55.51.78.22.22.48.38.78.5.3.11.63.17.99.17s.68-.05,1-.16c.33-.11.65-.31.96-.57l.99,1.26c-.41.31-.89.55-1.43.71-.54.17-1.08.25-1.62.25ZM31.76,66.48v-2.83h1.59v3.06l-1.59-.23Z'
      fill='#252c7e'
      strokeWidth='0'
    />
    <path
      d='M12.35,62.42h3.63v1.36h-3.63v-1.36ZM12.47,65.52h4.1v1.4h-5.84v-7.54h5.7v1.4h-3.96v4.74ZM17.97,66.92v-7.54h1.44l4.45,5.43h-.7v-5.43h1.72v7.54h-1.43l-4.46-5.43h.7v5.43h-1.72ZM30.3,67.05c-.6,0-1.15-.09-1.65-.28-.5-.19-.93-.47-1.3-.82-.37-.35-.65-.76-.86-1.24-.2-.47-.3-.99-.3-1.56s.1-1.09.3-1.56c.21-.47.5-.89.87-1.24.37-.35.81-.62,1.31-.81.5-.19,1.06-.29,1.66-.29.67,0,1.27.11,1.8.33.54.22.99.55,1.36.97l-1.12,1.03c-.27-.29-.57-.5-.89-.64-.32-.14-.67-.22-1.06-.22s-.7.06-1,.17c-.3.11-.56.28-.79.5-.22.22-.38.47-.51.76-.11.29-.17.62-.17.98s.06.67.17.97c.12.29.29.55.51.78.22.22.48.38.78.5.3.11.63.17.99.17s.68-.05,1-.16c.33-.11.65-.31.96-.57l.99,1.26c-.41.31-.89.55-1.43.71-.54.17-1.08.25-1.62.25ZM31.76,65.87v-2.83h1.59v3.06l-1.59-.23Z'
      fill='#fff'
      strokeWidth='0'
    />
  </svg>,
  'ENG',
);
